import React, { useState } from "react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { Link, useNavigate } from "react-router-dom";
import { mainLogo, mainTitle } from "../../../config";
import { routeNames } from "../../../routes/routeNames";
import { newServices, newSpecialities } from "../../../utils/NewData";
import { IoIosArrowDown } from "react-icons/io";

const Header = ({ showTopBar = true }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();

  // State to manage dropdown visibility
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isDropdownSpecOpen, setDropdownSpecOpen] = useState(false);

  // Function to open dropdown
  const handleMouseEnter = () => {
    setDropdownOpen(true);
  };

  // Function to close dropdown
  const handleMouseLeave = () => {
    setDropdownOpen(false);
  };

  // Mouse events for showing and hiding dropdowns

  const handleMouseEnterSpecialties = () => setDropdownSpecOpen(true);
  const handleMouseLeaveSpecialties = () => setDropdownSpecOpen(false);

  return (
    <div className="relative z-50">
      <header className="bg-background shadow-lg py-3 px-6 z-10">
        <div className=" flex justify-between items-center">
          {/* Logo and Title */}
          <div
            onClick={() => navigate(routeNames.home)}
            className="flex items-center space-x-3 cursor-pointer lg:space-x-2"
          >
            <img src={mainLogo} alt="Logo" className="h-14 w-14" />{" "}
            {/* Replace with actual logo */}
            <div className="flex flex-col items-center">
              <h1 className="text-2xl text-primary italic font-lato font-bold lg:text-3xl">
                {mainTitle}
              </h1>
              <div className="flex items-center space-x-2">
                <span className="w-10 h-[1px] bg-green"></span>
                <h3 className="text-md text-primary font-lato italic lg:text-md">
                  Feel the Relief
                </h3>
                <span className="w-10 h-[1px] bg-green"></span>
              </div>
            </div>
          </div>

          {showTopBar && (
            <>
              {/* Mobile Menu Toggle */}
              <button className="text-gray-800 xl:hidden" onClick={toggleMenu}>
                {isOpen ? (
                  <XIcon className="h-6 w-6" />
                ) : (
                  <MenuIcon className="h-6 w-6" />
                )}
              </button>

              {/* Desktop Navigation */}
              <nav className="hidden xl:flex space-x-10 items-center">
                
                {/* <Link
                  to={routeNames.services}
                  className="hover:text-primary hover:border-b-2 border-primary font-primary font-semibold text-lg"
                >
                  Services
                </Link> */}

                <div className="relative" onMouseLeave={handleMouseLeave}>
                  <button
                    id="dropdownInformationButton"
                    className={`text-xl font-semibold hover:text-primary hover:border-b-2 border-primary  focus:text-primary   text-center inline-flex items-center transition-all duration-300 ease-in-out transform ${
                      isDropdownOpen && "text-primary"
                    }`}
                    type="button"
                    onMouseEnter={handleMouseEnter}
                  >
                    <div className="flex items-center justify-center">
                      <h3 className="m-1">Services</h3>
                      <IoIosArrowDown />
                    </div>
                  </button>

                  {/* Dropdown content */}
                  {isDropdownOpen && (
                    <div
                      id="dropdownInformation"
                      className="absolute z-10 bg-background text-center   divide-gray-100 rounded-lg shadow-lg w-56 py-4 opacity-0 transform transition-all duration-300 ease-in-out scale-90 origin-top-right"
                      onMouseLeave={handleMouseLeave}
                      style={{
                        animation: "fadeInDown 0.3s forwards",
                        maxHeight: "400px",
                        overflowY: "auto",
                      }}
                    >
                      {newServices.map((item, index) => (
                        <div
                          key={index}
                          className="flex flex-col space-y-2 px-2 py-1"
                        >
                          <Link
                            to={item.link}
                            className="text-primary hover:text-secondary font-medium transition-colors duration-300 ease-in-out"
                          >
                            {item.title}
                          </Link>
                          {index < newServices.length - 1 && (
                            <hr className="border-t border-gray-200" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* <button className="text-xl font-semibold hover:text-primary">
                Services
              </button>
              {showServicesDropdown && (
                <div className="absolute left-0 mt-2 w-96 bg-white rounded-md shadow-lg z-20 grid grid-cols-2 gap-x-8 gap-y-2 p-4">
                  {services.map((item, index) => (
                    <div key={index} className="flex flex-col space-y-2">
                      <Link
                        to={item.link}
                        className="text-black hover:text-secondary"
                      >
                        {item.title}
                      </Link>
                      <hr className="border-t border-gray-300" />
                    </div>
                  ))}
                </div>
              )} */}
                </div>

                <div
                  className="relative"
                  onMouseLeave={handleMouseLeaveSpecialties}
                >
                  <button
                    id="dropdownInformationButton"
                    className={`text-xl font-semibold hover:border-b-2 border-primary  hover:text-primary  text-center inline-flex items-center transition-all duration-300 ease-in-out transform ${
                      isDropdownSpecOpen && "text-primary"
                    }`}
                    type="button"
                    onMouseEnter={handleMouseEnterSpecialties}
                  >
                    <div className="flex items-center justify-center">
                      <h3 className="p-1">Specialities</h3>
                      <IoIosArrowDown />
                    </div>
                  </button>

                  {/* Dropdown content */}
                  {isDropdownSpecOpen && (
                    <div
                      id="dropdownInformation"
                      className="absolute z-10 bg-background text-center  rounded-lg shadow-lg w-56 py-4 opacity-0 transform transition-all duration-300 ease-in-out scale-90 origin-top-right"
                      onMouseLeave={handleMouseLeaveSpecialties}
                      style={{
                        animation: "fadeInDown 0.3s forwards",
                        maxHeight: "400px",
                        overflowY: "auto",
                      }}
                    >
                      {newSpecialities.map((item, index) => (
                        <div
                          key={index}
                          className="flex flex-col space-y-2 px-2 py-1"
                        >
                          <Link
                            to={item.link}
                            className="text-primary hover:text-secondary font-medium transition-colors duration-300 ease-in-out"
                          >
                            {item.title}
                          </Link>
                          {index < newSpecialities.length - 1 && (
                            <hr className="border-t border-gray-300" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <Link
                  to={routeNames.Blog}
                  className="hover:text-primary hover:border-b-2 border-primary font-primary font-semibold  text-xl"
                >
                  Our Blog
                </Link>
                <Link
                  to={routeNames.aboutus}
                  className="hover:text-primary hover:border-b-2 border-primary font-primary font-semibold  text-xl"
                >
                  About Us
                </Link>
                <Link
                  to={routeNames.contact}
                  className="inline-block bg-primary text-white py-3 px-6 rounded-full font-primary text-lg font-semibold shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-secondary hover:to-primary"
                >
                  Contact Us
                </Link>
              </nav>
            </>
          )}
        </div>

        {/* Mobile Menu Overlay */}
        {isOpen && showTopBar && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 xl:hidden"
            onClick={toggleMenu}
          ></div>
        )}

        {/* Mobile Navigation */}
        {showTopBar && (
          <div
            className={`fixed top-0 right-0 h-full w-[75%] bg-white shadow-xl p-6 transform transition-transform duration-300 ${
              isOpen ? "translate-x-0" : "translate-x-full"
            } z-50 xl:hidden`}
          >
            <button
              className="absolute top-4 right-6 text-gray-800"
              onClick={toggleMenu}
            >
              <XIcon className="h-8 w-8" />
            </button>
            <div
                onClick={() => navigate(routeNames.home)}
                className="flex mt-5 items-center space-x-2 cursor-pointer"
              >
                <img src={mainLogo} alt="Logo" className="h-10 w-10" />
                <h1 className="text-xl font-bold">{mainTitle}</h1>
              </div>

            <nav className="space-y-6 text-lg mt-10 flex flex-col font-medium">
              <Link
                to={routeNames.home}
                className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
                onClick={toggleMenu}
              >
                Home
              </Link>
              <Link
              to={routeNames.services}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              Services
            </Link>
            <Link
              to={routeNames.specialities}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              Specialities
            </Link>
              
              <Link
              to={routeNames.Blog}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              Our Blog
            </Link>
            <Link
              to={routeNames.aboutus}
              className="text-xl font-semibold hover:text-primary transition-all duration-300 ease-in-out transform"
            >
              About Us
            </Link>
            <Link
              to={routeNames.contact}
              className="inline-block bg-primary text-center text-white py-2 px-6 rounded-full font-primary text-md font-semibold shadow-lg transition-transform transform hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-secondary hover:to-primary"
            >
              Contact Us
            </Link>
            </nav>
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;
